import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { endpoints } from "../lib/api";
import { APP_NAME, FRANCHISE_NAME } from "../lib/branding";
import QrClockIn from "./timesheets/QrClockIn";

/* Public, unauthenticated site clock-in portal. Most subcontractors (and many
 * field employees) have no account in the system at all — this page exists
 * specifically so scanning a site QR or badge with a plain phone camera works
 * without ever needing to sign in to the main app. */
export default function PublicClockIn() {
    const [searchParams] = useSearchParams();
    const code = searchParams.get("code");
    const [employees, setEmployees] = useState([]);
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        endpoints.publicEmployees().then((r) => setEmployees(r.data || [])).catch(() => {});
        endpoints.publicProjects().then((r) => setProjects(r.data || [])).catch(() => {});
    }, []);

    return (
        <div className="min-h-screen bg-[var(--rom-bg)] flex flex-col items-center py-8 px-4" data-testid="public-clockin-page">
            <div className="w-full max-w-md">
                <div className="flex items-center gap-3 mb-6 justify-center">
                    <img src="/servpro-logo.png" alt="SERVPRO" className="w-10 h-10 object-contain" draggable={false} />
                    <div className="text-center">
                        <div className="font-display font-black text-lg leading-none">{APP_NAME}</div>
                        <div className="text-[10px] tracking-[0.18em] uppercase text-[var(--rom-text-3)]">{FRANCHISE_NAME} · Site Clock-in</div>
                    </div>
                </div>
                <QrClockIn employees={employees} projects={projects} initialCode={code} />
            </div>
        </div>
    );
}
